import { render, staticRenderFns } from "./addrstaff.vue?vue&type=template&id=e6ec3c5e&scoped=true&"
import script from "./addrstaff.vue?vue&type=script&lang=js&"
export * from "./addrstaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ec3c5e",
  null
  
)

export default component.exports